import Dialog from "dialog";
import template from "./dialog-config.html";
import css from "./dialog-config.css";
import sleep from "sleep";

class ConfigEZORTDDialog extends Dialog {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-dialog-config-ezortd", ConfigEZORTDDialog);
  }
  constructor() {
    super();

    document.addEventListener("onupdatedevices", this.onupdatedevices_handler.bind(this));

    this.onupdatedevices_handler({detail: application.devices});

    this.show();
  }
  onupdatedevices_handler(event) {
    var devices = event.detail;

    this.textboxDeviceID.value = devices.ezortdSensor.id;
    this.textboxDeviceStatus.value = devices.ezortdSensor.status;
    this.textboxValue.value = devices.ezortdSensor.value;
    this.textboxCalibrationStatus.value = devices.ezortdSensor.calibrationStatus;
  }
  buttonClose_click(event) {
    this.close();
  }
  async buttonClearCalibration_click() {
    try {
      this.buttonClearCalibration.style.pointerEvents = "none";
      this.buttonClearCalibration.icon.iconname = "view-refresh";
      await server.rcall("RM_ezortd_clearCalibration");
      this.buttonClearCalibration.icon.iconname = "dialog-ok-apply";
    } catch(e) {
      this.buttonClearCalibration.icon.iconname = "process-stop";
    } finally {
      await sleep(3000);
      this.buttonClearCalibration.icon.iconname = "dialog-ok";
      this.buttonClearCalibration.style.pointerEvents = "";
    }
  }
  async buttonCalibrateTo_click() {
    try {
      this.buttonCalibrateTo.style.pointerEvents = "none";
      this.buttonCalibrateTo.icon.iconname = "view-refresh";
      await server.rcall("RM_ezortd_calibrateTo", parseFloat(this.textboxCalibrateTo.value));
      this.buttonCalibrateTo.icon.iconname = "dialog-ok-apply";
    } catch(e) {
      this.buttonCalibrateTo.icon.iconname = "process-stop";
    } finally {
      await sleep(3000);
      this.buttonCalibrateTo.icon.iconname = "dialog-ok";
      this.buttonCalibrateTo.style.pointerEvents = "";
    }
  }  
  close() {
    super.close();
  }
}

ConfigEZORTDDialog.constructor();

export default ConfigEZORTDDialog;